import { get, post } from 'api/request'

export const API_ADDRESS = "/address/service"

export const getSubdistrictList = (country, q) => get(`${API_ADDRESS}/subdistrict`, { urlParams: {country, q}})
